/**
 * Zeile in der Versionen-Karte (Design 2d): Badge v-Nummer + Titel + Zeitpunkt/Status.
 *
 * UX-Paket 26.08.2026, Punkt 5: `kompakt` markiert die aktive Zeile NICHT mehr in Primärfarbe —
 * dieselbe Akzentfarbe wie der "Senden vorbereiten"-Button liess die Versionen-Karte optisch mit
 * dem eigentlichen Haupt-CTA konkurrieren. In `kompakt` bleibt Primärfarbe exklusiv dem Senden-CTA
 * vorbehalten, die aktive Version hebt sich nur noch neutral (Fettung + dezenter Grauton) ab.
 */
export function VersionRow({ badge, title, sub, active, kompakt }: { badge: string; title: string; sub: string; active?: boolean; kompakt?: boolean }) {
  const hervorgehoben = active && !kompakt;
  return (
    <div
      className={`flex items-center gap-2.5 rounded-[9px] px-2.5 py-2 ${
        hervorgehoben
          ? "border-[1.5px] border-primary bg-primary/[0.07]"
          : active
            ? "border border-outline-variant/60 bg-surface-container-high/70 dark:border-outline/30 dark:bg-white/[0.04]"
            : "border border-outline-variant/50 bg-surface-container-low dark:border-outline/30 dark:bg-surface-variant/10"
      }`}
    >
      <span
        className={`grid h-[22px] w-[22px] shrink-0 place-items-center rounded-md text-[10.5px] font-bold ${
          hervorgehoben ? "bg-primary text-on-primary" : "bg-surface-container-high text-on-surface-variant dark:bg-surface-variant/50"
        }`}
      >
        {badge}
      </span>
      <div className="min-w-0 flex-1">
        <div className={`truncate text-[12px] ${active ? "font-semibold" : "font-medium"} text-on-background dark:text-inverse-on-surface`}>
          {title}
        </div>
        <div className="truncate text-[10.5px] text-on-surface-variant/70">{sub}</div>
      </div>
    </div>
  );
}
